import { IconSparkles } from '@posthog/icons';
import { CalloutBox } from 'components/Docs/CalloutBox';
import Pricing from 'components/Pricing/PricingCalculator/SingleProduct';
import * as React from 'react';
export default {
  IconSparkles,
  CalloutBox,
  Pricing,
  React
};